/**
 * Integrytas Base App · MOBILE primitive
 * Page header (Direction C) — 24/700 title + one-line description, with an
 * optional right-aligned actions slot. Wraps the .m-phead-* classes so mobile
 * pages compose rather than hand-roll the header.
 */
import type { ReactNode } from 'react';

interface MobilePageHeaderProps {
  title: string;
  description?: string;
  /** Right-aligned actions (e.g. a small add / refresh button). */
  actions?: ReactNode;
}

export function MobilePageHeader({ title, description, actions }: MobilePageHeaderProps) {
  return (
    <div className="m-phead-row">
      <div className="m-phead">
        <div className="m-ptitle">{title}</div>
        {description && <div className="m-pdesc">{description}</div>}
      </div>
      {actions && <div className="m-phead-actions">{actions}</div>}
    </div>
  );
}
